<div class="header-container left-container" [ngClass]="iconTypeLayoutClass()">
  <div class="logo-container">
    <a (click)="openModalMenu()" class="sidebar-toggle pr-4" *ngIf="this.menu?.menuitems?.length">
      <img [src]="exists(menu) && exists(menu.image) ? menu.image : '/assets/images/bt-menu.svg'" width="27px" height="27px" class="mr-1">
    </a>
    <a href="#" class="sidebar-toggle pr-4" *ngIf="!this.menu?.menuitems?.length">
    </a>
    <a class="logo" href="#" (click)="navigateHome()">
      <img src="assets/images/img-logo-horiz.webp">
    </a>

    <ul class="header-menu" *ngIf="headerMenu">

      <li class="control-item"
        [ngClass]="headerMenuItemClass('produtos')"
        *ngIf="enableTimeline && headerMenuItems > 1">
        <a [routerLink]="'/produtos'" class="header-menu-item">
          <img src="/assets/images/bt-home-header.svg" width="27px" height="27px" class="mr-1">
          {{ getTimelineLabel() }}
        </a>
      </li>

      <li class="control-item"
        [ngClass]="headerMenuItemClass('comunidade')"
        *ngIf="enableSocialMedia && headerMenuItems > 1">
        <a [routerLink]="isAuthenticated() ? '/comunidade' : '/login'" class="header-menu-item">
          <img src="/assets/images/bt-comunidade-header.svg" width="27px" height="27px" class="mr-1">
          {{ getSocialMediaLabel() }}
        </a>
      </li>

      <li class="control-item"
          [ngClass]="activeMenu ? 'active': ''"
          *ngIf="this.menu?.menuitems?.length">
        <a (click)="openModalMenu()" class="header-menu-item" style="cursor: pointer;">
          <img [src]="this.menu.image ? this.menu.image : '/assets/images/bt-menu.svg'" width="27px" height="27px" class="mr-1">
          {{ getTranslate("menu") }}
        </a>
      </li>
    </ul>

  </div>
</div>

<div class="header-container right-container" [ngClass]="iconTypeLayoutClass()">
  <ul class="header-menu" *ngIf="!router.url.includes('/comunidade')">

    <li class="control-item"
        [ngClass]="headerMenuItemClass('buscar')"
        *ngIf="enableSearchButton">
      <a [routerLink]="'/buscar'" class="header-menu-item">
        <img src="/assets/images/bt-search-header.svg" width="27px" height="27px" class="mr-1">
        {{ getTranslate("search") }}
      </a>
    </li>

  </ul>

  <nb-actions size="small" *ngIf="isAuthenticated() && exists(user)">
    <nb-action class="user-action" *nbIsGranted="['view', 'user']" >
      <nb-user *ngIf="userMenu.length"
               [nbContextMenu]="userMenu"
               [name]="user?.name"
               [picture]="user?.image || this?.home?.holder_avatar || './assets/images/ic-avatar-register.svg'">
      </nb-user>
    </nb-action>
  </nb-actions>
  <div class="logo-container" *ngIf="!isAuthenticated()">
    <a class="menu-login" href="#" (click)="navigateLogin()">
        {{ getTranslate("signIn") }}
    </a>
  </div>
</div>
